import { DocumentFormFields } from "@/common/types/forms/DocumentFormFields.type";
import { SearchVendorByName } from "@/components";
import SearchCustomerByName from "@/components/Customer/SearchCustomerByName/SearchCustomerByName";
import Typography from "@/components/Typography/Typography";
import { Form, FormInstance } from "antd";

export default function DocumentCompanyByName({
  form,
  selectedCompanyType,
}: {
  form: FormInstance<DocumentFormFields>;
  selectedCompanyType: string;
}) {
  return (
    <div>
      <Typography
        mb={4}
        type="p"
        fontFamily="font-kanit"
        fontWeight="font-light"
        fontSize={16}
      >
        Company name
        <Typography
          type="span"
          fontFamily="font-kanit"
          fontWeight="font-light"
          textColor="error"
        >
          *
        </Typography>
      </Typography>
      <Form.Item
        name="company"
        rules={[{ required: true, message: "Please select a company name" }]}
      >
        {selectedCompanyType === "vendor" && (
          <SearchVendorByName
            func={(data) => {
              form.setFieldsValue({
                company: {
                  name: data.label,
                  id: data.value,
                },
              });
            }}
          />
        )}
        {selectedCompanyType === "customer" && (
          <SearchCustomerByName
            labelClassName="hidden"
            className="bg-gray-border hover:bg-primaryDim"
            onChange={(data) => {
              form.setFieldsValue({
                company: {
                  name: data.label,
                  id: data.value,
                },
              });
            }}
          />
        )}
      </Form.Item>
    </div>
  );
}
